import { ColumnType, RootState, TicketType } from "types";
import "./tickets.scss";
import { Draggable } from "react-beautiful-dnd";
import Ticket from "components/board/ticket";
import { ContextMenu, ContextMenuTrigger, MenuItem } from "react-contextmenu";
import { FaArchive } from "react-icons/fa";
import api from "api";
import { useSelector } from "react-redux";
import { Fragment, useEffect, useMemo } from "react";
import { useBoardContext } from "context/boardContext";

interface props {
    tickets: TicketType[];
    index: number;
    columns: ColumnType[];
    setColumns: React.Dispatch<React.SetStateAction<ColumnType[]>>;
}

function Tickets({ tickets, index, columns, setColumns }: props) {
    const user = useSelector((state: RootState) => state.user);
    const { isArchived } = useBoardContext();

    const archiveTicket = (e: any, data: any) => {
        var ticketId = data.ticketId;
        var ticketName = data.ticketName;
        let archiveBoard = window.confirm(`Are you sure you want to archive: "${ticketName}"?`);

        if (archiveBoard) {
            api.ticket.archive(ticketId, user.Id).then(() => {
                removeTicket(data.ticketId);
            });
        }
    };

    const removeTicket = (ticketId: number) => {
        var newState = [...columns];
        for (var i of newState) {
            var indexToRemove = i.Tickets.map((item) => item.TicketDetails.Id).indexOf(ticketId);
            console.log("indexToRemove", indexToRemove);
            ~indexToRemove && i.Tickets.splice(indexToRemove, 1);
        }
        setColumns(newState);
    };

    const UnArchiveTicket = (e: any, data: any) => {
        var ticketId = data.ticketId;
        var ticketName = data.ticketName;
        let archiveBoard = window.confirm(`Are you sure you want to Unarchive: "${ticketName}"?`);

        if (archiveBoard) {
            api.ticket.UnArchive(ticketId, user.Id).then(() => {
                removeTicket(data.ticketId);
            });
        }
    };

    useEffect(() => {}, [tickets]);

    return (
        <>
            {!tickets.length ? (
                <i>No Tickets</i>
            ) : (
                tickets.map((x: TicketType, i: number) => {
                    return (
                        <Fragment key={i}>
                            <ContextMenuTrigger id={`contextmenu${x.TicketDetails.Id}`}>
                                <Draggable draggableId={`t_${x.TicketDetails.Id}`} index={i} key={`t_${x.TicketDetails.Id}`}>
                                    {(provided) => {
                                        return (
                                            <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                <Ticket item={x} />
                                            </div>
                                        );
                                    }}
                                </Draggable>
                            </ContextMenuTrigger>
                            <ContextMenu id={`contextmenu${x.TicketDetails.Id}`}>
                                {isArchived === false && (
                                    <MenuItem data={{ ticketId: x.TicketDetails.Id, ticketName: x.TicketDetails.Heading }} onClick={archiveTicket}>
                                        <FaArchive style={{ color: "white" }} />
                                        <span style={{ color: "white" }}>Archive Ticket</span>
                                    </MenuItem>
                                )}
                                {isArchived === true && (
                                    <MenuItem data={{ ticketId: x.TicketDetails.Id, ticketName: x.TicketDetails.Heading }} onClick={UnArchiveTicket}>
                                        <FaArchive style={{ color: "white" }} />
                                        <span style={{ color: "white" }}>Unarchive Ticket</span>
                                    </MenuItem>
                                )}
                            </ContextMenu>
                        </Fragment>
                    );
                })
            )}
        </>
    );
}

export default Tickets;
